module.exports = __webpack_public_path__ + "img/gx.f1a4048c.png";